import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// PrimeNG
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

// Shared Components
// import { ResuableTableComponent } from '../shared/components/resuable-table/resuable-table.component';
// import { DashboardCardComponent } from '../shared/components/dashboard-card/dashboard-card.component';

// Modal Component
import { AddEditTicketModalComponent } from './add-edit-ticket-modal/add-edit-ticket-modal.component';
import { TicketTableComponent } from './ticket-table/ticket-table.component';
import { StatusHistoryModalComponent } from './status-history-modal/status-history-modal.component';
import { CommentModalComponent } from './comment-modal/comment-modal.component';
import { ApiService } from '../../../services/api.service';
import { Subscription } from 'rxjs';

export interface Ticket {
  id?: number;
  ticketNo?: string;
  title: string;
  description: string;
  priority: string;
  status: string;
  module?: string;
  subModule?: string;
  subSection?: string;
  project?: string;
  section?: string;
  subSubSection?: string;
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: string;
  assignedTo?: string;
}

@Component({
  selector: 'app-ticket-management',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    ToastModule,
    AddEditTicketModalComponent,
    TicketTableComponent,
    StatusHistoryModalComponent,
    CommentModalComponent
  ],

  templateUrl: './ticket-management.component.html',
  styleUrls: ['./ticket-management.component.css']
})
export class TicketManagementComponent implements OnInit {
  showAddTicketModal = false;
  editingTicket: Ticket | null = null;
  showStatusHistoryModal = false;
  showCommentModal = false;
  selectedTicket: Ticket | null = null;

  // Statistics
  totalTickets = 11;
  openTickets = 3;
  progressTickets = 2;
  resolvedTickets = 2;
  closedTickets = 3;
  reOpenTickets = 1;

  // Status Cards for Statistics
  statusCards: any[] = [];

  // Table Configuration
  // tableColumns = [
  //   { field: 'priority', header: 'Priority', type: 'text' },
  //   { field: 'status', header: 'Status', type: 'text' },
  //   { field: 'createdAt', header: 'Created Date', type: 'text' },
  //   { field: 'createdBy', header: 'Created By', type: 'text' },
  //   { field: 'assignedTo', header: 'Assigned To', type: 'text' }
  // ];
    tableColumns = [
    { field: 'ticketNo', header: 'Ticket No.', type: 'text' },
    { field: 'title', header: 'Title', type: 'text' },
    { field: 'description', header: 'Description', type: 'text' },
    { field: 'priority', header: 'Priority', type: 'text' },
    { field: 'status', header: 'Status', type: 'text' },
    { field: 'createdAt', header: 'Created Date', type: 'text' },
    { field: 'createdBy', header: 'Created By', type: 'text' },
    { field: 'assignedTo', header: 'Assigned To', type: 'text' },
    { field: 'project', header: 'Project', type: 'text' },
    { field: 'module', header: 'Module', type: 'text' },
    { field: 'section', header: 'Section', type: 'text' },
    { field: 'subSection', header: 'Sub Section', type: 'text' }
  ];

  tickets: Ticket[] = [
    {
      id: 1,
      ticketNo: 'T.36',
      title: 'gdfsgdsf',
      description: '¥',
      priority: 'High',
      status: 'In Progress',
      createdAt: new Date('2025-05-30'),
      createdBy: 'SHIKHAR',
      assignedTo: 'ILIZIEN',
      project: 'Project X',
      module: 'Module Y',
      section: 'Section Z',
      subSection: 'Sub-section A'
    },
    {
      id: 2,
      ticketNo: 'T.28',
      title: 'TEST ticket',
      description: 'zxsdfvbgdcbn.',
      priority: 'High',
      status: 'Open',
      createdAt: new Date('2025-01-28'),
      createdBy: 'DSP_DADMIN',
      assignedTo: 'ILIZIEN',
      project: 'Project A',
      module: 'Module 1',
      section: 'Section Alpha',
      subSection: 'Sub-section i'
    }
  ];
private subscriptions = new Subscription();
  constructor(private messageService: MessageService,    private api: ApiService,
  ) {}

  ngOnInit(): void {
    // Load tickets from service if needed
      this.getTicketStats();
    this.initializeStatusCards();
    this.getTickets();
  }
   ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

 initializeStatusCards(): void {
  this.statusCards = [
    {
      label: 'TOTAL TICKETS',
      count: this.totalTickets,
      icon: 'fa-solid fa-clipboard-list',
      iconColor: '#1e40af',
      borderColor: '#1e40af',
      description: 'View Details'
    },
    {
      label: 'OPEN TICKETS',
      count: this.openTickets,
      icon: 'fa-solid fa-folder-open',
      iconColor: '#059669',
      borderColor: '#059669',
      description: 'Last Updated'
    },
    {
      label: 'PROGRESS TICKETS',
      count: this.progressTickets,
      icon: 'fa-solid fa-tasks',
      iconColor: '#dc2626',
      borderColor: '#dc2626',
      description: 'Ongoing'
    },
    {
      label: 'RESOLVED TICKETS',
      count: this.resolvedTickets,
      icon: 'fa-solid fa-circle-check',
      iconColor: '#16a34a',
      borderColor: '#16a34a',
      description: 'Well Done!'
    },
    {
      label: 'CLOSED TICKETS',
      count: this.closedTickets,
      icon: 'fa-solid fa-lock',
      iconColor: '#6b7280',
      borderColor: '#6b7280',
      description: 'No Actions Required'
    },
    {
      label: 'RE-OPEN TICKETS',
      count: this.reOpenTickets,
      icon: 'fa-solid fa-rotate-right',
      iconColor: '#ea580c',
      borderColor: '#ea580c',
      description: 'Follow Up'
    }
  ];
}

  onAddTicket(): void {
    this.editingTicket = null;
    this.showAddTicketModal = true;
  }

  onEditTicket(ticket: Ticket): void {
    this.editingTicket = ticket;
    this.showAddTicketModal = true;
  }

  onTicketSaved(ticket: Ticket): void {
    if (this.editingTicket) {
      // Update existing ticket
      const index = this.tickets.findIndex(t => t.id === ticket.id);
      if (index !== -1) {
        this.tickets[index] = ticket;
      }
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Ticket updated successfully'
      });
    } else {
      // Add new ticket
      ticket.id = this.tickets.length + 1;
      ticket.ticketNo = `T.${ticket.id}`;
      this.tickets.push(ticket);
      this.totalTickets++;
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Ticket created successfully'
      });
    }
    this.showAddTicketModal = false;
    this.editingTicket = null;
  }

  onModalClose(): void {
    this.showAddTicketModal = false;
    this.editingTicket = null;
  }

  onCardClick(type: string): void {
    // Handle card click for filtering
    console.log('Card clicked:', type);
    // You can add filtering logic here based on the card type
  }

  // onViewTicket(ticket: Ticket): void {
  //   console.log('View ticket:', ticket);
  // }
  onViewTicket(ticket: Ticket): void {
    this.editingTicket = ticket;
    this.showAddTicketModal = true;
  }

onDeleteTicket(ticket: any) {
  console.log('Delete ticket:', ticket);

  

  const payload = {
    id: ticket.id,
    delete: true
  };

  const sub = this.api.postAPI('/ticket/details/', payload)
    .subscribe(() => {

      this.messageService.add({
        severity: 'success',
        summary: 'Deleted',
        detail: 'Ticket deleted successfully'
      });

      this.getTickets();

    });

  this.subscriptions.add(sub);

}

  onStatusChange(event: {ticket: Ticket, newStatus: string}): void {
    event.ticket.status = event.newStatus;
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Status updated successfully'
    });
  }

  onViewStatus(ticket: Ticket): void {
    this.selectedTicket = ticket;
    this.showStatusHistoryModal = true;
  }

  onStatusHistoryModalClose(): void {
    this.showStatusHistoryModal = false;
    this.selectedTicket = null;
  }

  onViewComments(ticket: Ticket): void {
    this.selectedTicket = ticket;
    this.showCommentModal = true;
  }

  onCommentModalClose(): void {
    this.showCommentModal = false;
    this.selectedTicket = null;
  }

  onCommentAdded(comment: any): void {
    // Handle comment added event if needed
    console.log('Comment added:', comment);
  }
getTickets() {
  this.api.getAPI('/ticket/details/').subscribe((res: any) => {

    if (res.status === 200) {

      this.tickets = res.data.map((item: any) => ({
        id: item.id,
        ticketNo: item.ticket_number,
        title: item.title,
        description: item.description,
        priority: item.priority ? item.priority.charAt(0).toUpperCase() + item.priority.slice(1) : '',
        status: item.status ? item.status.replace('_', ' ').replace(/\b\w/g, (c: string) => c.toUpperCase()) : '',
        createdAt: item.created_on,
        createdBy: item.created_by_info
          ? item.created_by_info.first_name + ' ' + item.created_by_info.last_name
          : '',
        assignedTo: item.assigned_to_info
          ? item.assigned_to_info.first_name + ' ' + item.assigned_to_info.last_name
          : 'Unassigned',
        project: '',
        module: '',
        section: '',
        subSection: ''
      }));

    }

  });
}

getTicketStats() {
  this.api.getAPI('/ticket/stats/').subscribe((res: any) => {

    if (res.status === 200) {

      const data = res.data;

      this.totalTickets = data.total_tickets;
      this.openTickets = data.open_tickets;
      this.progressTickets = data.in_progress_tickets;
      this.resolvedTickets = data.resolved_tickets;
      this.closedTickets = data.closed_tickets;

      // API does not send reopen tickets so set default
      this.reOpenTickets = data.tickets_by_status?.re_open || 0;

      this.initializeStatusCards();

    }

  });
}
}

